import { MUSTNeverHappenException, exists } from '@nu-art/ts-common';
import { ModuleFE_Advisor_AdvisorSnippet } from '@app/advisor-frontend';
import { calculateWizardTree_Variable } from './variable-calculation.js';
//######################### Tree Calculation #########################
export const calculateWizardTree = (snippetIds, variableData, config) => {
    return {
        type: 'root',
        alwaysExpanded: true,
        item: {},
        _children: snippetIds.map(id => calculateWizardTree_Snippet(id, variableData, config))
    };
};
const calculateWizardTree_Snippet = (snippetId, variableData, config) => {
    const children = [];
    const snippet = ModuleFE_Advisor_AdvisorSnippet.cache.unique(snippetId);
    if (!snippet)
        throw new MUSTNeverHappenException(`Could not get snippet for _id ${snippetId}`);
    //Convert relevant formVars into child nodes
    if (snippet.formVariables?.length) {
        const formVarsToShow = snippet.formVariables.filter(formVar => {
            //Don't show variable if it isn't common and doesn't have data
            if (!formVar?.isCommon && !exists(variableData.item[formVar.id]))
                return false;
            const data = variableData.item[formVar.id]?.[0];
            //Don't show variable if data says it is chief complaint but the snippet doesn't show chief complaints
            if (!snippet.config.showChiefComplaints && data?.isChiefComplaint)
                return false;
            //Don't show variable if data says it's not a chief complaint but the snippet shows only chief complaints
            if (snippet.config.onlyChiefComplaints && !data?.isChiefComplaint)
                return false;
            return true;
        });
        children.push(...formVarsToShow.map(formVar => {
            const editable = variableData.editProp(formVar.id, []);
            editable.setOnDelete(() => variableData.updateObj({ [formVar.id]: undefined }));
            return calculateWizardTree_Variable(formVar, editable, config);
        }));
    }
    return {
        type: 'snippet',
        item: {
            id: snippetId,
            editable: variableData,
            disabled: config.disabled,
        },
        _children: children,
    };
};
//# sourceMappingURL=utils.js.map